import React from 'react'
import { Container, Label, SpinnerWrapper } from './styles'

type Props = {
  style?: object
  label?: string
}

const Spinner: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <Container style={props.style}>
      <SpinnerWrapper
        style={props.style}
        className={`${props.label && 'is-label'}`}
      />
      {props.label && <Label>{props.label}</Label>}
    </Container>
  )
}

export default Spinner
